import { handleActions } from 'redux-actions';

const defaultQuestionnaire = {};

export default handleActions({}, defaultQuestionnaire);
